import axios from "src/lib/axios";

export const getRefundOrderList = ({
  keyword,
  page,
  page_size,
  status,
  date,
  seller,
  failedReason,
  sortBy,
  sortOrder,
}) => {
  return axios.get(`/refunds`, {
    params: {
      seller,
      keyword,
      orderDate: date,
      cancelReason: failedReason,
      sortBy,
      orderCase: sortOrder,
      page,
      page_size,
      status,
    },
  });
};

/**
 *
 * @param {ObjectId} orderId
 * @returns
 */
export const getCancelOrderDetail = (id) => axios.get(`/refunds/${id}`);

/**
 *
 * @param {ObjectId} id
 * @param {Object} info
 * @param {File} info.paymentProof
 * @param {Date} info.paymentDate
 * @param {number} info.total
 * @param {string} info.remark
 * @returns
 */
export const updateStatusRefund = (id, info) => {
  return axios.patch(`/refunds/${id}`, info, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

/**
 *
 * @param {ObjectId} id
 * @param {Object} info
 * @param {number} info.total
 * @param {string} info.remark
 * @returns
 */
export const updateTotalRefund = (id, info) => {
  return axios.patch(`/refunds/edit-total/${id}`, info);
};

/**
 *
 * @param {ObjectId} id
 * @param {Object} info
 * @param {string} info.note
 * @returns
 */
export const updateCancelNote = (id, info) => {
  return axios.patch(`/refunds-note/${id}`, info);
};
